import './styles/main.scss';
import { PRODUCT_FORMS } from './constants';
import Widget from './widget';

alert('hello world');

export function checkTestMode() {
    if (!window.location) return false;
    const url = new URL(window.location.href);
    return !!url.searchParams.get('recharge');
}

export function findProductId(form) {
    // We'll want to use the product ID to ensure we're anchoring the correct product widget
    return (
        form.getAttribute('data-productid') || window.meta?.product?.id || null
    );
}

window.RcWidgets = [];

// Add Widget class to the ReCharge namespaced object
window.ReCharge = {
    Widget
};

const testMode = checkTestMode();
const productForms = document.querySelectorAll(PRODUCT_FORMS.join(','));

try {
    [...productForms].forEach(productForm => {
        /*
            Handles automatic creation of widgets
            - Will search through the page for product forms
            - We'll pass the product ID with the form
            - We'll instantiate the widget on all possible candidates
            Note: is this efficient? What happens if we have 50 products on a page, and only 1 is a subscription
        */
        const productId = findProductId(productForm);
        if (productId) {
            const widget = new Widget({
                debug: testMode,
                productId,
                productForm
            });
            widget.build();
        }
    });
} catch (e) {
    window.console.error('Widget build failed:', e);
}

if (testMode) {
    window.alert('ReCharge preview mode.');
}
